import { render, staticRenderFns } from "./notReadNotice-back.vue?vue&type=template&id=3a11d40b&scoped=true&"
import script from "./notReadNotice-back.vue?vue&type=script&lang=js&"
export * from "./notReadNotice-back.vue?vue&type=script&lang=js&"
import style0 from "./notReadNotice-back.vue?vue&type=style&index=0&id=3a11d40b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a11d40b",
  null
  
)

export default component.exports